module.exports = __webpack_public_path__ + "img/wlf.e3ac728c.svg";